/**
 * 获取子应用路径正则
 * @param entry 入口
 */
export const getSubAppPathRegexp = (entry?: string) => {
  return `${[undefined, null, '', '/'].includes(entry) ? '' : `/${entry}`}/:path(.*)*`
}
